import { Users, Target, Zap } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { FeatureCard } from './FeatureCard';

export function AIExplanation() {
  const { t } = useTranslation('translation', {
    keyPrefix:
      'pages.Personalization.components.SimilarProducts.components.AIExplanation.featureCard',
  });

  return (
    <div className="mt-8 rounded-lg border border-gray-200 bg-white p-5">
      <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        <FeatureCard
          icon={<Users className="h-8 w-8 text-purple-500" />}
          title={t('userBehavior.title')}
          description={t('userBehavior.description')}
        />

        <FeatureCard
          icon={<Target className="h-8 w-8 text-purple-500" />}
          title={t('intentPerdiction.title')}
          description={t('intentPerdiction.description')}
        />

        <FeatureCard
          icon={<Zap className="h-8 w-8 text-purple-500" />}
          title={t('realTimeProcessing.title')}
          description={t('realTimeProcessing.description')}
        />
      </div>
    </div>
  );
}
